import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
 getLoadUsuario (params) {
    return Api().post('/authenticate', params)
  },
  requestPasswordReset (params) {
    return Api().post('/account/reset-password/init', params)
  },
  changePassword (params) {
    return Api().post('/account/change-password', params)
  },
  changePasswordNotSession (params) {
    return Api().post('/account/reset-password/finish', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/LoadUsuario.js